import { useEffect, useState } from 'react';

const LINK_PATTERNS = {
  'Google Docs': /docs\.google\.com\/document/i,
  'Google Drive': /drive\.google\.com/i,
  Confluence: /\.atlassian\.net\/wiki/i,
  Notion: /notion\.so|notion\.site/i,
  Figma: /figma\.com\/(file|proto|design)/i,
  GitHub: /github\.com/i,
  Amplitude: /analytics\.amplitude\.com|app\.amplitude\.com/i,
};

export function useLinkValidation(url: string) {
  const [detectedType, setDetectedType] = useState<string | null>(null);
  const [isValidUrl, setIsValidUrl] = useState(false);

  useEffect(() => {
    if (!url || url.trim() === '') {
      setDetectedType(null);
      setIsValidUrl(false);
      return;
    }

    // Validate URL format
    try {
      new URL(url);
      setIsValidUrl(true);
    } catch {
      setIsValidUrl(false);
      setDetectedType(null);
      return;
    }

    // Detect link type
    for (const [type, pattern] of Object.entries(LINK_PATTERNS)) {
      if (pattern.test(url)) {
        setDetectedType(type);
        return;
      }
    }

    // If no match found, set to 'Other'
    setDetectedType('Other');
  }, [url]);

  return { detectedType, isValidUrl };
}
